import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { InjectApp } from '../app/app';
import { PassengerBlurb } from '../segment/passenger-detail';
import { CompensationDetails } from './compensation-details';
import { RedeemForm } from './redeem-form';
import { RedeemHeader } from './redeem-header';

interface RouteMatch {
  readonly passengerID: string;
}

@withRouter
@observer
export class RedeemInner extends React.Component<RouteComponentProps<RouteMatch> & InjectApp> {
  public render() {
    const { app, match } = this.props;

    const passenger = app.booking.passengers.find((p) => String(p.id) === match.params.passengerID);
    if (!passenger)
      throw new Error('Passenger was not found on current booking.');

    if (!passenger.voucher)
      throw new Error('Voucher was not found for passenger on booking.');

    return (
      <div className="redeem">
        <RedeemHeader/>

        <div className="container">
          <PassengerBlurb className="redeem-passenger" passenger={passenger}/>
          <CompensationDetails segment={app.booking.segment} voucher={passenger.voucher}/>
          <RedeemForm passenger={passenger}/>
        </div>
      </div>
    );
  }
}

export const Redeem = inject('app')(withRouter(RedeemInner)) as React.ComponentClass;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/redeem/redeem.tsx